/* Café Perfection V2.9: small paginated storefront responses, preview-safe, no persistent product cache. */
(function (w) {
  'use strict';
  if (w.CPCatalogue) return;
  var state='idle', result=null, pending=null, subscribers=[], started=0;
  function rootPath(){return ((w.Shopify&&w.Shopify.routes&&w.Shopify.routes.root)||'/').replace(/\/?$/,'/');}
  function baseURL(mode){
    var u=new URL(rootPath()+'collections/all',location.origin);
    if(u.origin!==location.origin)throw new Error('Invalid catalogue origin');
    u.searchParams.set(mode==='view'?'view':'section_id',mode==='view'?'cp-catalogue':'cp-catalogue-feed');
    var preview=new URL(location.href).searchParams.get('preview_theme_id');
    var t=w.CPThemeContext||(w.Shopify&&w.Shopify.theme)||{};
    if(!preview&&t.role&&t.role!=='main'&&t.role!=='MAIN')preview=String(t.id||'');
    if(preview&&/^\d+$/.test(preview))u.searchParams.set('preview_theme_id',preview);
    u.searchParams.set('_cp_catalogue',String(started));return u;
  }
  function slotList(sub){
    var notes=sub.root.querySelectorAll('[data-smart-note]');
    if(notes.length)return Array.from(notes);
    var own=sub.root.querySelector('[data-result-products-note],[data-cp-catalogue-status]');
    if(own)return [own];
    if(!sub.notice){sub.notice=document.createElement('div');sub.notice.className='cp-catalogue-status';sub.notice.setAttribute('role','status');sub.notice.setAttribute('aria-live','polite');sub.root.insertBefore(sub.notice,sub.root.firstChild);}
    return [sub.notice];
  }
  function message(sub,text,retry){
    if(!sub.root.isConnected)return;
    slotList(sub).forEach(function(box){
      box.hidden=false;box.textContent=text;
      if(retry){var b=document.createElement('button');b.type='button';b.textContent='Try again';b.className='cp-catalogue-retry';b.dataset.cpCatalogueRetry='';b.addEventListener('click',function(){load().catch(function(){});});var a=document.createElement('a');a.href=rootPath()+'collections/all';a.textContent='Browse the range';a.className='cp-catalogue-browse';box.append(document.createElement('br'),b,a);}
    });
  }
  function broadcast(text,retry){subscribers.forEach(function(s){message(s,text,retry);});}
  function notify(ok,value){
    subscribers=subscribers.filter(function(s){return s.root.isConnected;});
    subscribers.forEach(function(s){
      if(s.notice)s.notice.hidden=ok;
      s.root.querySelectorAll('[data-cp-catalogue-retry]').forEach(function(b){b.remove();});
      try{if(ok)s.success(value);else if(s.failure)s.failure(value);}
      catch(e){message(s,'Please reload this tool, or browse the range.',false);if(w.console)console.warn('CP catalogue consumer',e);}
    });
  }
  function parsePayload(raw){
    var text=String(raw||'').replace(/^\uFEFF/,'').trim();
    if(text.charAt(0)==='{')return JSON.parse(text);
    var doc=new DOMParser().parseFromString(text,'text/html');
    var node=doc.querySelector('script[data-cp-catalogue-payload]');
    if(!node)throw new Error('Catalogue response has no product payload');
    return JSON.parse(node.textContent);
  }
  async function request(url){
    var controller=typeof AbortController==='function'?new AbortController():null,timer;
    try{return await Promise.race([
      fetch(url.toString(),{credentials:'same-origin',cache:'no-store',headers:{Accept:'text/html,application/json'},signal:controller?controller.signal:undefined}).then(function(r){if(!r.ok)throw new Error('Catalogue HTTP '+r.status);return r.text();}).then(parsePayload),
      new Promise(function(_,reject){timer=setTimeout(function(){if(controller)controller.abort();reject(new Error('Catalogue request timed out'));},20000);})
    ]);}finally{clearTimeout(timer);}
  }
  function validate(data,page,total,size){
    if(!data||data.schemaVersion!==2||!Array.isArray(data.items)||!Number.isInteger(data.total)||data.total<0||data.total>=25000||data.page!==page||!Number.isInteger(data.pages)||!Number.isInteger(data.pageSize)||data.pageSize<1||data.pageSize>250)throw new Error('Invalid catalogue response');
    var pages=Math.max(1,data.pages);
    if(pages!==Math.max(1,Math.ceil(data.total/data.pageSize)))throw new Error('Invalid catalogue pagination');
    if(total!==null&&(data.total!==total||data.pageSize!==size))throw new Error('Catalogue changed while loading');
    if(data.items.length!==Math.max(0,Math.min(data.pageSize,data.total-(page-1)*data.pageSize)))throw new Error('Incomplete catalogue page');
    if((page<pages&&!data.next)||(page===pages&&data.next))throw new Error('Invalid continuation');
    return pages;
  }
  function seed(){try{var n=document.querySelector('[data-cp-catalogue-bootstrap]');if(!n)return null;var d=JSON.parse(n.textContent);validate(d,1,null,null);return d;}catch(_){return null;}}
  async function collect(){
    var mode='section',base=baseURL(mode),page=1,total=null,size=null,pages=null,items=[],seen=new Set(),data=seed();
    while(true){
      if(!data){var u=new URL(base);u.searchParams.set('page',String(page));try{data=await request(u);}catch(e){if(page!==1||mode==='view')throw e;mode='view';base=baseURL(mode);u=new URL(base);u.searchParams.set('page','1');data=await request(u);}}
      pages=validate(data,page,total,size);total=data.total;size=data.pageSize;
      data.items.forEach(function(p){
        if(!p||!p.id||!p.handle||!p.title||seen.has(String(p.id)))throw new Error('Incomplete or duplicate product');
        var url=new URL(p.url,location.origin);if(url.origin!==location.origin||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(url.pathname))throw new Error('Invalid product URL');
        seen.add(String(p.id));items.push(p);
      });
      if(page===pages){if(items.length!==total)throw new Error('Incomplete catalogue');return items;}
      var next=new URL(data.next,base),param=data.pageParam||'page';
      if(next.origin!==base.origin||!/^(page|page_[a-zA-Z0-9]+)$/.test(param)||Number(next.searchParams.get(param))!==page+1)throw new Error('Invalid catalogue continuation');
      // Rebuild our own URL. Never navigate to an arbitrary server-supplied destination.
      base=baseURL(mode);if(param!=='page')base.searchParams.set(param,String(page+1));
      page++;data=null;broadcast('Finding your options ('+items.length+' of '+total+' products)…',false);
    }
  }
  function load(){
    if(state==='ready')return Promise.resolve(result);if(pending)return pending;
    state='loading';started=Date.now();broadcast('Finding your options…',false);
    pending=collect().then(function(items){result=items;state='ready';pending=null;notify(true,items);document.dispatchEvent(new CustomEvent('cp:catalogue-ready',{detail:{count:items.length}}));return items;}).catch(function(e){result=null;state='error';pending=null;notify(false,e);broadcast('We could not load the product range. Your figures are saved on this page; try again or browse the range.',true);throw e;});return pending;
  }
  function connect(root,success,failure){
    if(!root||typeof success!=='function')return;
    var sub=subscribers.find(function(s){return s.root===root&&s.success===success;});
    if(!sub){sub={root:root,success:success,failure:failure,notice:null};subscribers.push(sub);}
    if(state==='ready'){Promise.resolve().then(function(){success(result);});return;}
    if(state==='error'){if(failure)failure(new Error('Catalogue unavailable'));message(sub,'The product range could not load. Please try again.',true);return;}
    load().catch(function(){});
  }
  w.CPCatalogue={connect:connect,load:load,status:function(){return state;}};
})(window);
